export const parseParamsFromParams = (value: string) => {
  if (!value) return [];

  return value.split(',').map((v: any) => v.trim().toUpperCase());
};
